import { useState } from "react";
import Hamburger from "../../assets/Hamburger";
import ResponsiveLogo from "../../assets/ResponsiveLogo";
import SidbarProfile from "../common/sidbarProfile/SidbarProfile";
import { Drawer } from "antd";
import Sidebar from "../common/sidebar/Sidebar";

export default function ResponsiveSidebar() {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  return (
    <div className="md:hidden flex w-full justify-between items-center p-4">
      <div onClick={showDrawer} className="cursor-pointer">
        <Hamburger />
      </div>
      <div>
        <ResponsiveLogo />
      </div>
      <div>
        <SidbarProfile />
      </div>
      <Drawer
        placement={"left"}
        closable={true}
        onClose={onClose}
        onClick={onClose}
        open={open}
        key={"left"}
        getContainer={false}
      >
        <Sidebar onlyMenu={true} />
      </Drawer>
    </div>
  );
}
